<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card
			[formGroup]="group"
			class="mat-elevation-z6 flex w-72 flex-col space-y-4"
		>
			<h3
				class="text-base font-bold"
				translate
			>
				reports.filter-bar.audit
			</h3>
			<div class="flex flex-col space-y-2">
				@if (!comegoTimes()) {
				<mat-checkbox
					color="primary"
					formControlName="project"
				>
					{{ 'project.none' | translate }}
				</mat-checkbox>
				<mat-checkbox
					color="primary"
					formControlName="task"
				>
					{{ 'task.none' | translate }}
				</mat-checkbox>
				} @else {
				<mat-checkbox
					color="primary"
					formControlName="rulebreaks"
				>
					{{ 'supervisor.rulebreaks' | translate }}
				</mat-checkbox>
				}
			</div>
			@if (!comegoTimes()) {<ng-container *ngTemplateOutlet="divider"></ng-container>
			<div class="flex flex-col">
				<mat-checkbox
					color="primary"
					formControlName="duration"
				>
					{{ 'task.duration.byduration' | translate }}
				</mat-checkbox>
			</div>
			<div class="items-between flex space-x-4">
				<div class="flex flex-auto flex-col">
					<h3
						class="mb-2 text-base font-bold"
						translate
					>
						task.duration.entries
					</h3>
					<mat-radio-group
						class="flex flex-col space-y-2"
						formControlName="mod"
					>
						<mat-radio-button
							[value]="0"
							color="primary"
						>
							{{ 'task.duration.longer' | translate }}
						</mat-radio-button>
						<mat-radio-button
							[value]="1"
							color="primary"
						>
							{{ 'task.duration.shorter' | translate }}
						</mat-radio-button>
					</mat-radio-group>
				</div>
				<div class="flex flex-col wflex-[0_0_100px]">
					<h3
						class="mb-2 text-base font-bold"
						translate
					>
						task.duration.than
					</h3>
					<tg-duration-input-control
						[displayFormat]="false"
						formControlName="modTime"
						placeholder="00:00"
					>
						<ng-template
							durationInputControl
							let-control="control"
							let-disabled="disabled"
							let-inputPlaceholder="inputPlaceholder"
						>
							<mat-form-field
								[matTooltip]="inputPlaceholder | translate"
								[matTooltipDisabled]="disabled"
								appearance="fill"
								class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain text-center"
								fxFill
							>
								<input
									[formControl]="control"
									matInput
									type="text"
								>
							</mat-form-field>
						</ng-template>
					</tg-duration-input-control>
				</div>
			</div>
			<ng-container *ngTemplateOutlet="divider"></ng-container>
			<div class="flex flex-col">
				<mat-form-field
					appearance="fill"
					class="mat-form-field-no-hint mat-form-field-plain"
				>
					<mat-label>{{ 'reports.exports.timezone' | translate }}</mat-label>
					<mat-select formControlName="timezone">
						<mat-option
							[value]="type.value"
							*ngFor="let type of timezoneTypes; let index = index"
						>
							{{ type.name | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			}
		</mat-card>
	</div>
</ng-template>
<ng-template #divider>
	<div class="-mx-16px my-2"><mat-divider inset></mat-divider></div>
</ng-template>
